// These functions should always be based on 16px even if the base font size
// changes, since the purpose is to make consistent rems or ems from familiar
// pixel values. The resulting values will scale properly just as if we had used
// rems directly.
export const toRem = (px: number) => `${px / 16}rem`

export const toPx = (s: string | number) =>
  typeof s !== 'string' ? s
  : s.endsWith('em') ? Math.round(parseFloat(s) * 16)
  : parseInt(s)
